import { COPY_NOT_SUPPORTED } from 'automation-ui-canvas/constants/AlertTypes';
import Action from 'automation-ui-action-features/records/Action';
import PortalIdParser from 'PortalIdParser';
import { canUseLocalStorage } from 'automation-ui-canvas/components/canvas/copyPaste/canUseLocalStorage';
import { LOCAL_STORAGE_COPIED_ACTION_KEY } from 'automation-ui-canvas/components/canvas/copyPaste/localStorageKeys';
export function copyActionToLocalStorage({
  flowId,
  flowObjectTypeId,
  action
}) {
  if (!canUseLocalStorage()) {
    throw new Error(COPY_NOT_SUPPORTED);
  }
  try {
    localStorage.setItem(LOCAL_STORAGE_COPIED_ACTION_KEY, JSON.stringify({
      portalId: PortalIdParser.get(),
      flowId,
      flowObjectTypeId,
      action
    }));
  } catch (error) {
    console.error(error);
  }
}
export function getPasteableData() {
  let copiedData;
  try {
    const rawData = localStorage.getItem(LOCAL_STORAGE_COPIED_ACTION_KEY);
    copiedData = JSON.parse(rawData || 'null');
    if (copiedData) {
      copiedData.action = new Action(copiedData.action);
    }
    return copiedData;
  } catch (error) {
    return {
      error: error
    };
  }
}